import Reef from "reefjs";

//// Data Store
const DATA_STORE = new Reef.Store({
  data: {},
});

export default DATA_STORE;
